import styled from '@emotion/styled';
import H4 from '@base/H4/H4';
import H7 from '@base/H7/H7';
import { keyframes } from '@emotion/react';
import { Spacings, mediaQuery } from '@styles/index';
import PlayCircleBig from '@icon/PlayCircleBig';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { getImage } from '@utils/imageHelper';
import LinearProgressBar from '@base/LinearProgressBar/LinearProgressBar';
import { boxShadowColorPercent, CLASS_STATE } from './constants';

const ShadowPulse = keyframes`
 0% { box-shadow: ${boxShadowGenerator({
   yOffset: Spacings.SPACING_0B,
   blur: Spacings.SPACING_0B,
   color: boxShadowColorPercent['0']
 })}; }
 70% { box-shadow: ${boxShadowGenerator({
   yOffset: Spacings.SPACING_0B,
   blur: Spacings.SPACING_0B,
   spread: '10px',
   color: boxShadowColorPercent['70']
 })}; }
 100% {
   box-shadow: none;
 }
`;

const Month = styled(H7)`
  width: ${Spacings.SPACING_10B};
  text-align: center;
  text-transform: uppercase;
  text-decoration: ${({ $isTextStrikeout = false }) =>
    $isTextStrikeout ? 'line-through' : 'unset'};
  color: ${({ $isTextStrikeout = false }) =>
    $isTextStrikeout
      ? 'var(--color-text-secondary)'
      : 'var(--color-text-primary)'};
`;

const Day = styled(H4)`
  text-align: center;
  color: var(--color-text-primary);
  text-decoration: ${({ $isTextStrikeout = false }) =>
    $isTextStrikeout ? 'line-through' : 'unset'};
  color: ${({ $isTextStrikeout = false }) =>
    $isTextStrikeout
      ? 'var(--color-text-secondary)'
      : 'var(--color-text-primary)'};
  ${mediaQuery.uptoTablet} {
    font-size: 18px;
  }
`;

const Live = styled(PlayCircleBig)`
  margin-right: ${Spacings.SPACING_6B};
  border-radius: 50%;
  box-shadow: ${boxShadowGenerator({
    yOffset: Spacings.SPACING_0B,
    blur: Spacings.SPACING_0B,
    color: boxShadowColorPercent['0']
  })};
  animation: ${ShadowPulse} 2s infinite;
  :hover {
    animation: none;
  }
`;

const Icon = styled.img`
  margin-right: ${Spacings.SPACING_6B};
  height: ${Spacings.SPACING_10B};
  width: ${Spacings.SPACING_10B};
  user-drag: none;
  user-select: none;
`;
const Play = styled(PlayCircleBig)`
  margin-right: ${Spacings.SPACING_6B};
`;

const BatchGroupLeftIcon = ({ lesson }) => {
  const { liveAt, startsAt, watchTime, lessonDuration } = lesson;
  const classState = lesson?.classState;
  const live = liveAt ? new Date(liveAt) : new Date(startsAt);

  if (classState === CLASS_STATE.LIVE_STATE) {
    return <Live size="40px" color="var(--color-i-red)" />;
  }

  if (classState === CLASS_STATE.COMPLETELY_WATCHED_STATE) {
    return (
      <Icon src={getImage('batch-group/completed-class.svg')} alt="icon" />
    );
  }
  if (classState === CLASS_STATE.NOT_WATCHED_STATE) {
    return <Play size="40px" color="var(--color-i-green)" />;
  }
  if (classState === CLASS_STATE.CONTINUE_WATCH_STATE) {
    return (
      <>
        <Play size="40px" color="var(--color-i-green)" />
        {watchTime ? (
          <LinearProgressBar
            value={Math.max((watchTime * 100) / lessonDuration, 10)}
            width="40px"
            backgroundColor="var(--color-divider)"
          />
        ) : null}
      </>
    );
  }
  if (classState === CLASS_STATE.ACCESS_ENDED_STATE) {
    return (
      <Icon src={getImage('batch-group/access-end-play-icon.svg')} alt="icon" />
    );
  }
  const isTextStrikeout =
    classState === CLASS_STATE.CANCELLED_STATE ||
    classState === CLASS_STATE.RESCHEDULED_STATE;
  return (
    <>
      <Month $isTextStrikeout={isTextStrikeout}>
        {live ? live.toLocaleString('default', { month: 'short' }) : ''}
      </Month>
      <Day $isTextStrikeout={isTextStrikeout}>
        {live ? live?.getDate() : ''}
      </Day>
    </>
  );
};
export default BatchGroupLeftIcon;
